import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { database } from "../firebaseConfig";
import { ref, get } from "firebase/database";
import "./Articolo.css";
//sezione.sottosezioni
const Articolo = () => {
    const { slug } = useParams(); // Recupera l'ID e slug dalla URL
    const navigate = useNavigate(); // Navigazione per tornare indietro
    const [articolo, setArticolo] = useState(null); // Stato per i dati dell'articolo
    const [mostraTutte, setMostraTutte] = useState(false); // Stato per mostrare tutte le curiosità
    //Stato per gestire il menù mobile o desktop
    const [menuOpen, setMenuOpen] = useState(false);


    //Creo un riferimento al percorso "sezioni" del database.
    //Recupero i dati da Firebase
    //
    useEffect(() => {
        const articoliRef = ref(database, "sezioni");
        get(articoliRef).then((snapshot) => {
            if (snapshot.exists()) {
                const sezioni = snapshot.val();
                //Variabile temporanea utilizzata per memorizzare l'articolo trovato durante la ricerca
                let trovato = null;

                    // Scansione di tutte le sezioni e sottosezioni per trovare l'articolo


                    // for (let sezione of sezioni) {
                    //     const articoloTrovato = sezione.articoli.find(
                    //         (articolo) => articolo.slug === slug
                    //     );
                    //     if (articoloTrovato){
                    //         trovato = articoloTrovato;
                    //         console.log(trovato)
                    //         break;
                    //     }
                    // }

                    //Ciclo su tutte le sezioni
                     sezioni.forEach(sezione => {
                        if(sezione.articoli){
                            Object.values(sezione.articoli).forEach(articoloItem =>{
                                if(articoloItem.slug === slug){
                                    trovato = articoloItem
                                }
                            });
                        }
                    })

                    if(trovato){
                        setArticolo(trovato);
                        console.log("Articolo", articolo)
                    } else {
                        console.error("Articolo non trovato.");
                    }
                }else{
                        console.error("Database vuoto o struttura non valida");
                     }

                    });
                }, [slug]);

    
        
        //Se l'articolo è "null" o ancora in fase di definizione, verrà mostrata la schermata di caricamento.
        if (!articolo) {
            return <p>Caricamento dell'articolo...</p>;
        }

      //Assegnazione condizionale
      //Creo una nuova variabile temporanea che contiene:
      // - Tutte le curiosità se "mostraTutte" è true
      // - Solo le prime 3 curiosità se "mostraTutte" è false
      //.slice(inizio, fine) restituisce una copia dell'array dal primo indice (0) fino al (3) escluso
        const curiositaDaMostrare = mostraTutte
        ? articolo.curiosita
        : articolo.curiosita.slice(0, 3);
       
        //Funzione per mostrare tutti gli articoli presenti
        const mostraArticoli = ()=>{
            setMostraTutte(true)
        };

                    
        //Pulsante rimosso provvisoriamente o definitivamente
        // <button className="back-button" onClick={() => navigate(-1)}>
        //         Torna indietro
        // </button> 

    return (

        <div >
             <div className="containerBar">
          <div className="containerNavBar">
            <nav className="navbar">
              <div className="logo">
                10<span>curiosita</span>.it
              </div>
              {/*Icona menù per dispositivi mobili */}
              <div className="menu-icon" onClick={()=> setMenuOpen(!menuOpen)}>
                ☰
              </div>
              {/* Menù di navigazione */}
              <ul className={`menu ${menuOpen ? "open" : ""}`}>
                <li><a href="/">Home</a></li>
                <li><a href="/articoli">Articoli</a></li>
                <li><a href="/curiosità-del-giorno">Curiosità del giorno</a></li>
                <li><a href="/contatti">Contatti</a></li>
              </ul>
            </nav>
            </div>
        </div>
            <section>
            <h1 className="articolo-title">{articolo.titolo}</h1>
            <p className="articolo-contenuto">{articolo.contenuto}</p>
            {articolo.curiosita && Array.isArray(articolo.curiosita) ? (
                <div>
                    <div className="divArticolo">
                        <ul className="articolo-curiosità">
                            {curiositaDaMostrare.map((curiosita, index) =>(
                                <div className="curiosita-card" key={index}>
                                        {/* <strong>{index + 1} </strong> */}
                                        <p>{index +1} - {curiosita}</p>
                                </div>
                            ))}
                        </ul>
                    </div>
                {!mostraTutte ? (
                <button className="mostra-button" onClick={mostraArticoli}>
                    Mostra tutto
                </button>
                ) : (
                    null
                )}
             </div>   
             
            ) : (
             <p>Nessuna curiosità disponibile</p>   
            )}
            </section>
        </div>
    );
};

export default Articolo;
